export const API_ENDPOINTS = {
    ORCHESTRATE_ORGANISATION_CONTACTS: '/orchestrate/organisations/contacts',
    PRODUCTS: '/api/order/v1/products',
    AGGREGATED_LEAD: '/api/aggregated/v1/leads',
    AGGREGATED_LEAD_ASSIGN: '/api/aggregated/v1/leads/assign',
    LEADS_INFO: '/api/aggregated/v1/leads/info',
    LEAD_MANAGEMENT: '/api/lead-management/v1/leads',
    CLIENT_REQUESTS: '/api/client-management/v1/client-requests',
    AGGREGATED_CLIENT_REQUESTS: '/api/aggregated/v1/client-requests',
    AGGREGATED_CLIENT_NOTIFICATION_CLIENT_REQUESTS:
        '/api/aggregated/v1/client-notification/client-requests',
    CLIENT_CONTACTS: '/api/client-management/v1/contacts',
    ACADEMIC_DETAILS: '/api/client-management/v1/additional-details',
    USER_MANAGEMENT_LOCATIONS: '/api/user-management/v1/locations',
    BULK_UPLOAD_CLIENT_REQUESTS: '/api/aggregated/v1/client-utility/bulk-upload',
    VALIDATE_STAGE: '/api/aggregated/v1/stage',
    POTENTIAL_DUPLICATES: '/api/client-management/v1/organisation/potential-duplicates',
    ORGANIZATION_ADDRESSES: '/api/aggregated/v1/client/organization-addresses',
    SHIKSHA_FUNDER: '/api/aggregated/v1/shiksha/funder',
    FUNDER_FUZZY_SEARCH: '/api/client-management/v1/shiksha/funder/fuzzy-search',
    LEADS_CREATED: '/api/aggregated/v1/leads/created',
    CLIENT_USER_SMART_SEARCH: '/api/aggregated/v1/client-user/smart-search',
    NOTIFICATION_TEMPLATE_DETAILS: '/api/notification/v1/template-details',
    SEND_NOTIFICATION: '/api/notification/v1/send-notification',
    zohoMailOauthStatus: (userId: string) =>
        `/api/notification/v1/integrations/zoho-mail/users/${encodeURIComponent(userId)}/oauth/status`,
    zohoMailDrafts: (userId: string) =>
        `/api/notification/v1/integrations/zoho-mail/users/${encodeURIComponent(userId)}/drafts`,
    RETENTION_QUALIFICATIONS: '/api/aggregated/v1/retention/qualifications',
    retentionQualificationById: (id: number) => `/api/aggregated/v1/retention/qualifications/${id}`,
    retentionQualificationRespond: (id: number) =>
        `/api/aggregated/v1/retention/qualifications/${id}/respond`,
} as const

export const CRM_DEFAULTS = {
    DEFAULT_LEAD_ID: 957,
} as const

export const API_PATH_SUFFIX = {
    LEAD_ORDER: '/order',
} as const
